import React from "react";
import type { WrapRootElementBrowserArgs, WrapRootElementNodeArgs } from "gatsby";
import {ParallaxProvider} from "react-scroll-parallax";
import {CookiesProvider} from "react-cookie";
import {ConsentContextWrapper} from "./src/contexts/consent.context";
import {NavbarContextWrapper} from "./src/contexts/navbar.context";

export const sharedWrapRootElement = ({ element }: WrapRootElementNodeArgs | WrapRootElementBrowserArgs) => (
        <ParallaxProvider>
            <CookiesProvider>
                <ConsentContextWrapper>
                    <NavbarContextWrapper>{element}</NavbarContextWrapper>
                </ConsentContextWrapper>
            </CookiesProvider>
        </ParallaxProvider>
);